import { Controller, useForm } from 'react-hook-form'
import UseEmpsTypes from '../../../hooks/use-emps-types'
import { Button, Col, Form, Row } from 'react-bootstrap'
import { BsSearch } from 'react-icons/bs'
import LabelCustom from '../../../components/label-custom'
import AutocompleteCustom from '../../../components/custom/autocomplete'
import ModalCustom from '../../../components/modal-custom'
import { useDebounce } from '@react-hook/debounce'
import UseEmpsCode from '../../../hooks/use-emps-code'
import UseEmpsUsername from '../../../hooks/use-emps-username'
import UseEmpsName from '../../../hooks/use-emps-name'
import UseEmpsReportby from '../../../hooks/use-emps-reportby'
import UseEmpsPosition from '../../../hooks/use-emps-position'
import UseEmpsLavel from '../../../hooks/use-emps-lavel'
import UseEmpsStatus from '../../../hooks/use-emps-status'
import UseTeamsAll from '../../../hooks/use-teams-all'
import CustomAutocomplete from '../../../components/CustomAutocomplete'
import AutocompleteMulti from '../../../components/AutocompleteMulti'
import UseEducationTypes from '../../../hooks/use-education-type'
import { useEffect } from 'react'

export default function ModalFilter({
  roleId,
  open,
  onCancel,
  fnGetData,
  isLoading,
  bodyFilter
}) {
  const {
    control,
    setValue,
    handleSubmit,
    formState: { errors }
  } = useForm()

  const educationTypes = UseEducationTypes()

  const [keyCode, setKeyCode] = useDebounce('', 1000)
  const empCode = UseEmpsCode(roleId, keyCode)
  const [keyName, setKeyName] = useDebounce('', 1000)
  const [keyUsername, setKeyUsername] = useDebounce('', 1000)
  const [keyReportTo, setKeyReportTo] = useDebounce('', 1000)
  const [keyPosition, setKeyPosition] = useDebounce('', 1000)
  const [keyTeam, setKeyTeam] = useDebounce('', 1000)

  const empUsername = UseEmpsUsername(roleId, keyUsername)
  const empName = UseEmpsName(roleId, keyName)
  const reportTo = UseEmpsReportby(roleId, keyReportTo)
  const empsTypes = UseEmpsTypes()
  const empPosition = UseEmpsPosition(roleId, keyPosition)
  const empsLavel = UseEmpsLavel()
  const empStatus = UseEmpsStatus()
  useEffect(() => {
    setValue('educationDegree', bodyFilter.educationDegree || '')
    setValue('institutionName', bodyFilter.institutionName || '')
    setValue('educationQualification', bodyFilter.educationQualification || '')
    setValue('faculty', bodyFilter.faculty || '')
    setValue('major', bodyFilter.major || '')
    setValue('code', bodyFilter.code || '')
    setValue('username', bodyFilter.username || '')
    setValue('name', bodyFilter.name || '')
    setValue('department', bodyFilter.works || '')
    setValue('reportTo', bodyFilter.reportTo || '')
    setValue('typeId', bodyFilter.typeId)
    setValue('statusId', bodyFilter.statusId || '')
    setValue('position', bodyFilter.position || '')
    setValue('team', bodyFilter.team || '')
    setValue('levelId', bodyFilter.levelId)
  }, [bodyFilter, setValue])

  // const bodyQuery = localStorage.getItem(BODY)
  const teams = UseTeamsAll(roleId, keyTeam)
  const onSubmit = (data) => {
    const datas = {
      works: data.department ?? '',
      code: data.code ?? '',
      username: data.username ?? '',
      name: data.name ?? '',
      statusId: data.statusId ?? '',
      typeId: data.typeId,
      positionId: data.position ?? '',
      position: data.position ?? '',
      nickname: data.nickname ?? '',
      reportTo: data.reportTo ?? '',
      team: data.team ?? '',
      teamId: data.team ?? '',
      ...(data.levelId && {
        levelId: data.levelId
      }),
      educationDegree: data.educationDegree ?? '',
      institutionName: data.institutionName ?? '',
      educationQualification: data.educationQualification ?? '',
      faculty: data.faculty ?? '',
      major: data.major ?? ''
    }
    const body = {
      page: 1,
      orgId: roleId,
      size: 20,
      ...datas
    }

    fnGetData(body)
    onCancel()
  }

  return (
    <ModalCustom width={1300} open={open} onCancel={onCancel}>
      <h4>Filter</h4>
      <Form onSubmit={handleSubmit(onSubmit)} className="mt-3">
        <Row style={{ rowGap: '15px' }}>
          <Col xl={3} md={4}>
            <LabelCustom text="Education Degree" />
            <Controller
              name={'educationDegree'}
              control={control}
              render={({ field: { onChange, value = '' } }) => (
                <AutocompleteCustom
                  placeholder={``}
                  isClearable={true}
                  options={educationTypes}
                  value={value}
                  onChange={onChange}
                />
              )}
            />
          </Col>
          <Col xl={3} md={4}>
            <LabelCustom text="Institution Name" />
            <Controller
              name={'institutionName'}
              control={control}
              render={({ field: { onChange, value = '' } }) => (
                <Form.Control value={value} onChange={onChange} />
              )}
            />
          </Col>
          <Col xl={3} md={4}>
            <LabelCustom text="Education Qualification" />
            <Controller
              name={'educationQualification'}
              control={control}
              render={({ field: { onChange, value = '' } }) => (
                <Form.Control value={value} onChange={onChange} />
              )}
            />
          </Col>
          <Col xl={3} md={4}>
            <LabelCustom text="Faculty" />
            <Controller
              name={'faculty'}
              control={control}
              render={({ field: { onChange, value = '' } }) => (
                <Form.Control value={value} onChange={onChange} />
              )}
            />
          </Col>
          <Col xl={3} md={4}>
            <LabelCustom text="Major" />
            <Controller
              name={'major'}
              control={control}
              render={({ field: { onChange, value = '' } }) => (
                <Form.Control value={value} onChange={onChange} />
              )}
            />
          </Col>

          <Col xl={3} md={4}>
            <LabelCustom text={'รหัสพนักงาน'} />
            <Controller
              name={'code'}
              control={control}
              render={({ field: { onChange, value = '' } }) => (
                <CustomAutocomplete
                  value={value}
                  placeholder=""
                  options={empCode}
                  onChange={(data) => {
                    onChange(data)
                    if (data && data.label) {
                      setKeyCode(data.label)
                    } else {
                      setKeyCode('')
                    }
                  }}
                  freeSolo={true}
                />
              )}
            />
          </Col>
          <Col xl={3} md={4}>
            <LabelCustom text="Username" />
            <Controller
              name={'username'}
              control={control}
              render={({ field: { onChange, value = '' } }) => (
                <CustomAutocomplete
                  value={value}
                  placeholder=""
                  options={empUsername}
                  onChange={(data) => {
                    onChange(data)
                    if (data && data.label) {
                      setKeyUsername(data.label)
                    } else {
                      setKeyUsername('')
                    }
                  }}
                  freeSolo={true}
                />
              )}
            />
          </Col>
          <Col xl={3} md={4}>
            <LabelCustom text="ชื่อพนักงาน" />
            <Controller
              name={'name'}
              control={control}
              render={({ field: { onChange, value = '' } }) => (
                <CustomAutocomplete
                  value={value}
                  placeholder=""
                  options={empName}
                  onChange={(data) => {
                    onChange(data)
                    if (data && data.label) {
                      setKeyName(data.label)
                    } else {
                      setKeyName('')
                    }
                  }}
                  freeSolo={true}
                />
              )}
            />
          </Col>

          <Col xl={3} md={4}>
            <LabelCustom text={'สายงาน/ฝ่าย/แผนก'} />
            <Controller
              name={'department'}
              control={control}
              render={({ field: { onChange, value = '' } }) => (
                <Form.Control value={value} onChange={onChange} />
              )}
            />
          </Col>
          <Col xl={3} md={4}>
            <LabelCustom text={'ผู้บังคับบัญชา'} />
            <Controller
              name={'reportTo'}
              control={control}
              render={({ field: { onChange, value = '' } }) => (
                <AutocompleteCustom
                  isClearable={true}
                  options={reportTo}
                  value={value}
                  onChange={onChange}
                  onInputChange={(data) => {
                    setKeyReportTo(data)
                  }}
                />
              )}
            />
          </Col>
          <Col xl={3} md={2}>
            <LabelCustom text="ประเภทพนักงาน" />
            <Controller
              name={'typeId'}
              control={control}
              render={({ field: { onChange, value = [] } }) => (
                <AutocompleteMulti
                  placeholder={``}
                  options={empsTypes}
                  value={value}
                  onChange={onChange}
                />
              )}
            />
          </Col>
          {/* <Col xl={3} md={4}>
            <LabelCustom text="สถานะทดลองงาน" />
            <Controller
              name={'probation'}
              control={control}
              render={({ field: { onChange, value = '' } }) => (
                <AutocompleteCustom
                  isClearable={true}
                  options={empProbations}
                  value={value}
                  onChange={onChange}
                />
              )}
            />
          </Col>

          <Col xl={3} md={2}>
            <LabelCustom text="ประเภทวันที่" />
            <Controller
              name={'typeDate'}
              control={control}
              render={({ field: { onChange, value } }) => (
                <AutocompleteCustom
                  isClearable={true}
                  options={typeDates}
                  value={value}
                  onChange={(data) => {
                    onChange(data)

                    if (data?.value === 2) {
                      setValue('statusId', {
                        value: '',
                        label: 'ทั้งหมด'
                      })
                    } else {
                      setValue('statusId', {
                        value: '1',
                        label: 'พนักงาน'
                      })
                    }
                  }}
                />
              )}
            />
          </Col>
          <Col xl={4} md={4}>
            <LabelCustom text="วันที่" />
            <Controller
              name={'date'}
              control={control}
              render={({ field: { onChange, value } }) => (
                <PickerRangeCustom
                  value={value}
                  onChange={(date) => {
                    if (date.length > 1) {
                      const st = fnDateEn(date[0]).format('YYYY-MM-DD')
                      const en = fnDateEn(date[1]).format('YYYY-MM-DD')
                      setValue('date', [st, en])
                    } else if (date.length === 0) {
                      setValue('date', ['', ''])
                    }
                  }}
                />
              )}
            />
          </Col> */}
          <Col xl={2} md={2}>
            <LabelCustom text="สถานะพนักงาน" />
            <Controller
              name={'statusId'}
              control={control}
              render={({ field: { onChange, value = null } }) => (
                <AutocompleteCustom
                  options={[{ value: '', label: 'ทั้งหมด' }, ...empStatus]}
                  value={value}
                  onChange={onChange}
                />
              )}
            />
          </Col>

          <Col xl={3} md={6}>
            <LabelCustom text="ตำแหน่ง " />
            <Controller
              name={'position'}
              control={control}
              render={({ field: { value = '', onChange } }) => (
                <CustomAutocomplete
                  value={value}
                  placeholder=""
                  options={empPosition}
                  onChange={(data) => {
                    onChange(data)
                    if (data && data.label) {
                      setKeyPosition(data.value)
                    } else {
                      setKeyPosition('')
                    }
                  }}
                  freeSolo={true}
                />
              )}
            />
          </Col>
          <Col xl={3} md={6}>
            <LabelCustom text="ทีม " />
            <Controller
              name={'team'}
              control={control}
              render={({ field: { value = '', onChange } }) => (
                <CustomAutocomplete
                  value={value}
                  placeholder=""
                  options={teams}
                  onChange={(data) => {
                    onChange(data)
                    if (data && data.label) {
                      setKeyTeam(data.value)
                    } else {
                      setKeyTeam('')
                    }
                  }}
                  freeSolo={true}
                />
              )}
            />
          </Col>
          <Col xl={4}>
            <LabelCustom text="Level " />
            <Controller
              name={'levelId'}
              control={control}
              render={({ field: { onChange, value = [] } }) => (
                <AutocompleteMulti
                  placeholder={``}
                  options={empsLavel}
                  value={value}
                  onChange={onChange}
                />
              )}
            />
          </Col>

          <Col xl={12} md={12} className="align-self-end text-end">
            <Button type="submit" disabled={isLoading} className=" px-4">
              <BsSearch /> ค้นหา{isLoading && '...'}
            </Button>
          </Col>
        </Row>
      </Form>
    </ModalCustom>
  )
}
